import helper from "./helper";
import cash from "cash-dom";

(function () {
    "use strict";
    if (cash('#day-info').length) {
        cash('.del__button').each((index, ele) => {
            ele.addEventListener('click', () => {
                helper.postAjax('api/info/delete', {
                    id: ele.dataset.id
                }, function (response) {
                    let parent = ele.closest('tr');
                    if (response == 200) {
                        parent.classList.remove('intro-x');
                        parent.classList.remove('opacity-100');
                        parent.classList.add('opacity-0');
                        setTimeout(() => {
                            parent.remove();
                        }, 300)
                    }
                })
            })
        })
    }


})();
